export const TREE_RUNTIME_SELECTOR_DIAGNOSTIC_KEYS =
  Object.freeze([
    'presentationUnresolvedCount',
    'presentationConflictingCount',
    'presentationInvalidCompatibilityCount',

    'branchCanonicalAdditionCount',
    'branchUnresolvedCount',
    'branchConflictingCount',

    'layoutParityCount',
    'layoutCanonicalAdditionCount',
    'layoutLegacyOnlyCount',
    'layoutMismatchCount',
    'layoutUnresolvedCount',
    'layoutConflictingCount',
    'layoutInvalidCompatibilityCount',

    'topologyParityCount',
    'topologyLegacyOnlyCount',
    'topologyCanonicalOnlyCount',
    'topologyGenerationMismatchCount',
    'topologyBranchPathMismatchCount',
    'topologyUnresolvedCount',

    'topologyCompatibilityUnresolvedCount',
    'topologyCompatibilityInvalidCount',
    'topologyCanonicalUnresolvedCount',
    'topologyCanonicalConflictingCount',
    'topologyLayoutPathMismatchCount',
    'topologyLayoutPathLegacyOnlyCount',
  ] as const);

export type TreeRuntimeSelectorDiagnosticKey =
  typeof TREE_RUNTIME_SELECTOR_DIAGNOSTIC_KEYS[number];

export type TreeRuntimeSelectorDiagnostics =
  Readonly<
    Record<
      TreeRuntimeSelectorDiagnosticKey,
      number
    >
  >;

export const sanitizeTreeRuntimeSelectorDiagnostics =
  (
    candidate: unknown,
  ): TreeRuntimeSelectorDiagnostics | null => {
    if (
      !candidate ||
      typeof candidate !== 'object'
    ) {
      return null;
    }

    const value =
      candidate as Record<string, unknown>;

    const sanitized =
      {} as Record<
        TreeRuntimeSelectorDiagnosticKey,
        number
      >;

    for (
      const key of
      TREE_RUNTIME_SELECTOR_DIAGNOSTIC_KEYS
    ) {
      const count = value[key];

      if (
        typeof count !== 'number' ||
        !Number.isInteger(count) ||
        count < 0 ||
        count > 1_000_000
      ) {
        return null;
      }

      sanitized[key] = count;
    }

    return Object.freeze(sanitized);
  };

export const createEmptyTreeRuntimeSelectorDiagnostics =
  (): TreeRuntimeSelectorDiagnostics =>
    Object.freeze(
      Object.fromEntries(
        TREE_RUNTIME_SELECTOR_DIAGNOSTIC_KEYS.map(
          key => [key, 0],
        ),
      ) as Record<
        TreeRuntimeSelectorDiagnosticKey,
        number
      >,
    );
